// extracted by mini-css-extract-plugin
export default {"bgNavbar":"navbar_bgNavbar__qoY9t"};